export const LOREN_HEADERS = {
    AUTHORIZATION: 'Authorization'
};
